/**
 * Format privacy-mode "who's coming" summary for class pages.
 */
export function formatRoleCounts(counts = {}) {
  const bits = [];
  if (counts.leads) bits.push(`${counts.leads} Lead${counts.leads === 1 ? "" : "s"}`);
  if (counts.followers) {
    bits.push(`${counts.followers} Follower${counts.followers === 1 ? "" : "s"}`);
  }
  if (counts.both) bits.push(`${counts.both} Both`);
  if (counts.unknown && !bits.length) {
    bits.push(`${counts.unknown} dancer${counts.unknown === 1 ? "" : "s"}`);
  } else if (counts.unknown && bits.length) {
    bits.push(`${counts.unknown} other`);
  }
  return bits.join(" · ");
}

export function formatPreviewNames(previewNames = [], total = 0) {
  const names = (previewNames || []).filter(Boolean);
  if (!names.length) {
    return total > 0 ? `${total} dancer${total === 1 ? "" : "s"} registered` : "";
  }
  const remaining = Math.max(0, total - names.length);
  if (remaining <= 0) {
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
  }
  const listed = names.join(", ");
  return `${listed}, and ${remaining} other${remaining === 1 ? "" : "s"}…`;
}

export function registeredCtaCopy(myRsvp, entitlementPreview) {
  if (!myRsvp || myRsvp.status === "CANCELLED") return null;
  const via = myRsvp.redemption_via || entitlementPreview?.via || null;
  if (via === "OFFER") {
    return {
      title: "You're in!",
      detail: "Your first class is free.",
    };
  }
  if (via === "TIME_PASS" || via === "FREE_RULE" || via === "COMMERCE_OFF") {
    return {
      title: "You're registered!",
      detail: null,
    };
  }
  return {
    title: "You're registered!",
    detail: "1 credit pending check-in.",
  };
}

/** Whether the deferred profile drawer should open after RSVP. */
export function needsClassProfileTodos({ rsvp, account, organizer, dancerProfile }) {
  organizer = account ?? organizer;
  if (!rsvp || rsvp.onboarding_completed_at) return false;
  const name = rsvp.name || organizer?.name || dancerProfile?.name;
  const phone = rsvp.phone || organizer?.phone || dancerProfile?.phone;
  const role = rsvp.role || dancerProfile?.role;
  return !String(name || "").trim() || !String(phone || "").trim() || !String(role || "").trim();
}
